import React, { useContext, useEffect, useState } from "react";
import { Card, Input, Button, Form, notification, Col } from "antd";
import logoImage from "../../assets/images/dashboard-vector.png";
import HTTP from "../../services/httpService";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { SettingContext } from "../../routes";

const defaultOTPDuration = 60;

function VerifyOTP() {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { setLoggedIn } = useContext(SettingContext);
    const [resetButton, setResetButton] = useState(true);
    const [timerSeconds, setTimerSeconds] = useState(0);
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    async function setResendTimer() {
        setResetButton(true);
        setTimerSeconds(defaultOTPDuration);
        const timerDate = moment().add(defaultOTPDuration, "second");
        const interval = setInterval(function () {
            const diff = Math.round((timerDate - moment()) / 1000);
            setTimerSeconds(diff);
            if (diff === 0) {
                setResetButton(false);
            }
            if (diff < 0) {
                clearInterval(interval);
            }
        }, 1000);
    }

    useEffect(() => {
        setResendTimer();
    }, []);

    async function handleOTPSubmit(values) {
        const { message, success } = await HTTP("/users/validateOTP", {
            ...values,
            staff_id,
        });

        if (!success) {
            notification["error"]({
                message: message,
            });
        } else {
            navigate("/");
            setLoggedIn(true);
        }
    }

    async function resedOTP() {
        form.resetFields();
        setResendTimer();
        const { message, success } = await HTTP("/users/resendOTP", {
            staff_id,
        });
        if (!success) {
            notification["error"]({
                message: message,
            });
        }
    }

    return (
        <div className="forget-container">
            <Card bordered={false} className="forget-card">
                <Col md={12}>
                    <div>
                        <img
                            src={logoImage}
                            alt="dashboard"
                            className="forget-dashboard-vector"
                        />
                    </div>
                </Col>
                <Col md={12}>
                    <div className="forget-contents">
                        <div className="title-container">Verify OTP</div>
                        <div className="forget-inputs">
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={handleOTPSubmit}
                            >
                                <Form.Item name="otp" required={true}>
                                    <Input
                                        id="otp"
                                        size="large"
                                        placeholder="Enter OTP"
                                    />
                                </Form.Item>

                                <div className="button-link-container">
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginRight: "10px" }}
                                    >
                                        Verify
                                    </Button>
                                    {resetButton ? (
                                        <span>
                                            {`00:${String(
                                                timerSeconds,
                                            ).padStart(2, "0")}`}
                                        </span>
                                    ) : (
                                        <Button
                                            type="primary"
                                            disabled={resetButton}
                                            onClick={resedOTP}
                                        >
                                            Resend OTP
                                        </Button>
                                    )}
                                </div>
                            </Form>
                        </div>
                    </div>
                </Col>
            </Card>
        </div>
    );
}

export { VerifyOTP };
